import React, {useCallback, useMemo} from 'react';
import styled from "styled-components";
import {TaxonomyTreeFilterUI} from "./TaxonomyTreeFilterUI";
import {ManufacturerFilterUI} from "./ManufacturerFilterUI";
import {SpeciesFilterUI} from "./SpeciesFilterUI";
import {CharacteristicsFilterUI} from "./CharacteristicsFilterUI";

const MenuContainer = styled.div`
    width: 100%;
    height: auto;
    position: relative;
    padding: 1rem;
    margin-bottom: 1.5rem;
    border: 1.1px solid #D0D0D0;

    &.taxonomy {
        overflow-wrap: anywhere;
        border: none;
        padding: 0;
    }
`;

const StylesContainer = styled.div`
    .taxonomy .MuiAccordion-gutters:before {
        display: none;
    }

    .taxonomy .form-select {
        border-radius: 0;
        height: 48px;
    }

    .taxonomy .subcategory {
        margin-top: 0;
    }

    .taxonomy .subsubcategory {
        margin-top: 0;
        border-top: 0;
    }

    .taxonomy .taxonomy-filters {
        margin-top: 2rem;
    }

    .taxonomy .taxonomy-dropdowns {
        margin-bottom: 1.5rem;
    }

    .categories-tree {
        margin-bottom: 1.5rem;
        padding: 0.5rem;
        border: 1px solid rgb(222, 226, 230);
    }

    .categories-tree div,
    .categories-tree select {
        border: none;
        background-color: transparent;
    }

    .accordion {
        border: 1px solid rgb(222, 226, 230);
    }

    .accordion .MuiButtonBase-root.MuiAccordionSummary-root.MuiAccordionSummary-gutters {
        padding-right: 10px;
    }
`;


const FILTER_KEYS = Object.freeze({
    taxonomyTree: 'taxonomyTree',
    manufacturerIds: 'manufacturerIds',
    species: 'species',
    characteristics: 'characteristics',
    // No es un filtro del panel, pero tiene que sobrevivir a updateFilter: si no esta en
    // allowedKeys, tocar cualquier filtro del panel borra la busqueda activa del navbar.
    search: 'search',
});


export const buildFilterPanelConfig = (options, selected, update) => [
    {
        Component: TaxonomyTreeFilterUI,
        options: options.macrofamilias,
        value: selected[FILTER_KEYS.taxonomyTree],
        onChange: update(FILTER_KEYS.taxonomyTree),
    },
    {
        Component: ManufacturerFilterUI,
        options: options.fabricantes,
        value: selected[FILTER_KEYS.manufacturerIds],
        onChange: update(FILTER_KEYS.manufacturerIds),
    },
    {
        Component: SpeciesFilterUI,
        options: options.especies,
        value: selected[FILTER_KEYS.species],
        onChange: update(FILTER_KEYS.species),
    },
    {
        Component: CharacteristicsFilterUI,
        options: options.caracteristicas,
        value: selected[FILTER_KEYS.characteristics],
        onChange: update(FILTER_KEYS.characteristics),
    },
];

export const FilterPanel = ({filterOptions, filter, onFilterChange}) => {

    const updateFilter = useCallback((key) => (value) => {
        const allowedKeys = Object.values(FILTER_KEYS);

        const newFilter = {
            ...Object.fromEntries(Object.entries(filter).filter(([k]) => allowedKeys.includes(k))),
            [key]: value,
        }
        console.log(newFilter);
        onFilterChange(newFilter);
    }, [filter]);

    const filterPanelConfig = useMemo(
        () => buildFilterPanelConfig(filterOptions, filter, updateFilter),
        [filterOptions, filter]);

    return (
        <StylesContainer>
            <MenuContainer className="taxonomy">
                {filterPanelConfig.map(({Component, options, value, onChange}, index) => (
                    <Component
                        key={index}
                        options={options}
                        value={value}
                        onChange={onChange}
                    />
                ))}
            </MenuContainer>
        </StylesContainer>
    )
};
